// Bill Summary Chart constants
export const FIELDS = [
  "energyCharges",
  "energyRevenue",
  "demandCharges",
  "fixedCharges",
  "subscribedCharges",
  "penaltyCharges",
];

export const COLORS = [
  "#0d47a1", // dark blue
  "#1565c0",
  "#1976d2",
  "#1e88e5",
  "#2196f3",
  "#42a5f5",
  "#64b5f6",
  "#90caf9", // light blue
];
export const AFTER_BAR_COLORS = [
  "#1b5e20", // dark green
  "#2e7d32",
  "#388e3c",
  "#43a047",
  "#4caf50",
  "#66bb6a",
  "#81c784",
  "#a5d6a7", // light green
];


export const FIELD_LABELS = {
  energyCharges: "Energy Charges",
  energyRevenue: "Energy Revenue",
  demandCharges: "Demand Charges",
  fixedCharges: "Fixed Charges",
  subscribedCharges: "Subscribed Charges",
  penaltyCharges: "Penalty Charges",
};

export const LEGEND_FIELDS = [
  ...FIELDS.map((f) => ({
    key: `before-${f}`,
    label: `${FIELD_LABELS[f]} (Before)`,
    group: "before",
    field: f,
  })),
  ...FIELDS.map((f) => ({
    key: `after-${f}`,
    label: `${FIELD_LABELS[f]} (After)`,
    group: "after",
    field: f,
  })),
];
